module.exports = __webpack_public_path__ + "img/setUpCards_notice.70c64d35.jpg";